'use strict';

angular.module('feedController', [])

.controller('FeedController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window', '$q', '$interval', '$timeout', 'PropertyService', 'SellerService', 'ContactService', 'AgentService', 'FeedService'
    ,function (appInfo, $scope, $rootScope, $log, $location, $window, $q, $interval, $timeout, PropertyService, SellerService, ContactService, AgentService, FeedService) {
    var ekey = $rootScope.currentUser.authdata;

    $scope.polling = false;
    $scope.newItems = false;

    $rootScope.header.show = false;
    $scope.page = 'news';

    $scope.feedServ = new FeedService.Feed;

    var checkItemExists = function(item) {
        var itemExists = false;
        angular.forEach($scope.feedServ.items, function(feedItem){
            if(item.id !== feedItem.id) {
                itemExists = true;
            }
        });

        return itemExists;
    }

    var poll = function() {
        // Don't start a new poll if we are already polling
        if ( $scope.polling ) return;

        $scope.polling = true;
        angular.element('.ui.feed').attr('infinite-scroll-disabled', true);
        
        FeedService.checkSellerFeed(10, 0).then(function(response){
            var newItems = [];
            response.reduce(function(p, val) { 
                return p.then(function() {
                    var duplicateItem = checkItemExists(val);

                    if(!duplicateItem) {
                         newItems.push(val);
                    }
                });
            }, $q.when(true)).then(function() {
                // Finished
                if(newItems.length > 0) {
                    $scope.newItems = true;

                    angular.forEach(newItems, function(item){
                        $scope.feedServe.items.splice(0, 1, item);
                    });
                }
            }).finally(function(){
                $scope.polling = false;
                 angular.element('.ui.feed').attr('infinite-scroll-disabled', false);
            });
        });
    }

   

    $scope.showNewItems = function() {
        $window.scrollTo(0, angular.element('.feed').offsetTop);  
        $scope.newItems = !$scope.newItems;
    }

    var init = function() {
        // Start polling the feed
        $scope.feedServ.nextPage();
        // $interval(function() {
        //     poll();
        // }, 120000, true);
       
    };

    init();

}]);